import React, { Component } from 'react';
import PropTypes from 'prop-types';

const styles = {
  root: {
    marginTop: 10,
    background: '#fff',
    border: '1px solid #e5e5e5',
    borderRadius: 3,
  },
  tab: {
    border: '1px solid #e5e5e5',
    borderRadius: 3,
  },
  content: {
    padding: 25,
  },
  label: {
    ul: {
      background: '#ececec',
      margin: 0,
      padding: 0,
    },
    li: {
      cursor: 'pointer',
      display: 'inline-block',
      link: {
        padding: '8px 12px',
        display: 'block',
        color: '#007fff',
        textDecoration: 'none',
        active: {
          color: '#444',
          fontWeight: 'bold',
          background: 'rgb(255, 255, 255)',
        },
      },
      active: {
        background: 'rgb(255, 255, 255)',
      },
    },
  },
};

class Tabs extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selected: this.props.selected || 0,
    };
  }

  shouldComponentUpdate(nextProps, nextState) {
    return this.props !== nextProps || this.state !== nextState;
  }

  handleClick(index, event) {
    event.preventDefault();
    this.setState({
      selected: index,
    });
  }

  renderTitles() {
    const labels = (child, index) => {
      const activeTabStyle = Object.assign({}, styles.label.li,
        (this.state.selected === index ? styles.label.li.active : {}));
      const activeLinkStyle = Object.assign({}, styles.label.li.link,
        (this.state.selected === index ? styles.label.li.link.active : {}));
      return (
        <li key={index} style={activeTabStyle}>
          <a
            style={activeLinkStyle}
            onClick={(e) => {
              this.handleClick(index, e);
            }}
          >
            {child.props.label}
          </a>
        </li>
      );
    };
    return (
      <ul style={styles.label.ul}>
        {
          Array.isArray(this.props.children) ?
            this.props.children.map(labels.bind(this)) : labels(this.props.children, 0)
        }
      </ul>
    );
  }

  renderContent() {
    return (
      <div style={styles.content}>
        {
          Array.isArray(this.props.children) ?
            this.props.children[this.state.selected] : this.props.children
        }
      </div>
    );
  }

  render() {
    return (
      <div style={styles.root}>
        {this.renderTitles()}
        {this.renderContent()}
      </div>
    );
  }
}

Tabs.propTypes = {
  selected: PropTypes.number.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.element,
  ]).isRequired,
};

export default Tabs;



// WEBPACK FOOTER //
// ./src/components/shared/Tabs.js